export default "__VITE_ASSET__MOlMcvb2__"